import type { SavedFlightPartyPricing } from 'tripPlanner/api/types'

export function getSavedFlightPerPersonPrice(saved: SavedFlightPartyPricing | undefined): {
  price?: number
  regularPrice?: number
  currencyCode?: string
} {
  const total = saved?.fareTotalPrice
  const count = saved?.farePricedPersonCount
  if (total === undefined || !Number.isFinite(total) || total < 0 ||
    count === undefined || !Number.isInteger(count) || count <= 0) {
    return { currencyCode: saved?.fareCurrencyCode }
  }
  const regularTotal = saved?.fareRegularTotalPrice
  return {
    price: total / count,
    regularPrice: regularTotal !== undefined && Number.isFinite(regularTotal) && regularTotal > total
      ? regularTotal / count
      : undefined,
    currencyCode: saved?.fareCurrencyCode,
  }
}

/** Matches the service's saved-fare divisor: adults plus children, excluding infants. */
export function getFlightPricedPersonCount(occupancies: Array<App.Occupants>): number | undefined {
  const count = occupancies.reduce((total, occupancy) => {
    const adults = Number.isInteger(occupancy.adults) && occupancy.adults >= 0 ? occupancy.adults : 0
    const children = occupancy.childrenAge?.length
      ? occupancy.childrenAge.filter(age => age >= 2).length
      : occupancy.children !== undefined && Number.isInteger(occupancy.children) && occupancy.children >= 0
        ? occupancy.children
        : 0
    return total + adults + children
  }, 0)
  return count > 0 ? count : undefined
}
